import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/Index'
import dataVIndex from '@/components/dataV/index'
import Index from '@/components/index/Index'
import ManageIndex from '@/components/manage/Index'
import ManageIndexComponent from '@/components/manage-components/index/Index'
import ManageNoticeComponent from '@/components/manage-components/notice/Index'
import ManageNewsComponent from '@/components/manage-components/news/Index'
import ManageDictComponent from '@/components/manage-components/dict/Index'
import ManageLogComponent from '@/components/manage-components/log/Index'
import ManageOrganizationComponent from '@/components/manage-components/organization/Index'
import ManagePermissionComponent from '@/components/manage-components/permission/Index'
import ManageUserComponent from '@/components/manage-components/user/Index'
import ManageRolerComponent from '@/components/manage-components/role/Index'
import ManageAiDataSetComponent from '@/components/manage-components/aiDataSet/Index'
import ManageAiDataSetAnalysisComponent from '@/components/manage-components/aiDataSetAnalysis/Index'
import ManageAiDataSetLabelComponent from '@/components/manage-components/aiDataSetLabel/Index'

import ManageDeviceProjectComponent from '@/components/manage-components/deviceProject/Index'
import ManageDeviceModelComponent from '@/components/manage-components/deviceModel/Index'
import ManageDeviceModelPropertyComponent from '@/components/manage-components/deviceModelProperty/Index'
import ManageCameraComponent from '@/components/manage-components/camera/Index'
import ManageDeviceOtaComponent from '@/components/manage-components/deviceOta/Index'
import ManageDeviceOtaRecordComponent from '@/components/manage-components/deviceOtaRecord/Index'
import ManageDeviceInstantiationComponent from '@/components/manage-components/deviceInstantiation/Index'
import ManageDeviceControlSenceActionModelComponent from '@/components/manage-components/deviceControlSenceActionModel/Index'

import OrgManageIndexComponent from '@/components/org-manage-components/index/Index'
import OrgManageAnalysisComponent from '@/components/org-manage-components/analysis/Index'
import OrgManageNoticeComponent from '@/components/org-manage-components/notice/Index'
import OrgManageNewsComponent from '@/components/org-manage-components/news/Index'
import OrgManageDepartmentComponent from '@/components/org-manage-components/department/Index'
import OrgManageLogComponent from '@/components/org-manage-components/log/Index'
import OrgManageOrganizationComponent from '@/components/org-manage-components/organization/Index'
import OrgManageUserComponent from '@/components/org-manage-components/user/Index'
import OrgManageUserInfoComponent from '@/components/org-manage-components/userinfo/Index'
import OrgManageAiDataSetComponent from '@/components/org-manage-components/aiDataSet/Index'

import BiotaComponent from '@/components/org-manage-components/biota/Index'
import BiotaGrowthModelComponent from '@/components/org-manage-components/biotaGrowthModel/Index'
import BiotaGrowthStageComponent from '@/components/org-manage-components/biotaGrowthStage/Index'
import BiotaGrowthStageDiseaseInsectPestComponent from '@/components/org-manage-components/biotaGrowthStageDiseaseInsectPest/Index'
import BiotaGrowthStageImagesComponent from '@/components/org-manage-components/biotaGrowthStageImages/Index'
import BiotaGrowthStageManureFeedComponent from '@/components/org-manage-components/biotaGrowthStageManureFeed/Index'
import BiotaGrowthStageModelAricultureOptComponent from '@/components/org-manage-components/biotaGrowthStageModelAricultureOpt/Index'
import GrowthConditionComponent from '@/components/org-manage-components/growthCondition/Index'
import KnowledgeComponent from '@/components/org-manage-components/knowledge/Index'
import KnowledgeBiotaComponent from '@/components/org-manage-components/knowledgeBiota/Index'
import ManureFeedComponent from '@/components/org-manage-components/manureFeed/Index'
import ChemicalCompositionComponent from '@/components/org-manage-components/chemicalComposition/Index'
import ComponentsComponent from '@/components/org-manage-components/components/Index'
import DiseaseInsectPestComponent from '@/components/org-manage-components/diseaseInsectPest/Index'
import DiseaseInsectPestDrugComponent from '@/components/org-manage-components/diseaseInsectPestDrug/Index'
import DiseaseInsectPestImageComponent from '@/components/org-manage-components/diseaseInsectPestImage/Index'
import DrugComponent from '@/components/org-manage-components/drug/Index'
import OrgManageGroundComponent from '@/components/org-manage-components/ground/Index'

import AricultureOptComponent from '@/components/org-manage-components/aricultureOpt/Index'
import AricultureOptBiotaGrowthStageComponent from '@/components/org-manage-components/aricultureOptBiotaGrowthStage/Index'
import AricultureOptBiotaGrowthStageFileComponent from '@/components/org-manage-components/aricultureOptBiotaGrowthStageFile/Index'
import AricultureOptDrugComponent from '@/components/org-manage-components/aricultureOptDrug/Index'
import AricultureOptManureFeedComponent from '@/components/org-manage-components/aricultureOptManureFeed/Index'

import OrgManageCameraComponent from '@/components/org-manage-components/camera/Index'
import OrgManageDeviceInstantiationGroupComponent from '@/components/org-manage-components/deviceInstantiationGroup/Index'
import OrgManageDeviceInstantiationComponent from '@/components/org-manage-components/deviceInstantiation/Index'
import OrgManageDeviceControlSenceComponent from '@/components/org-manage-components/deviceControlSence/Index'
import OrgManageDeviceControlRuleConditionComponent from '@/components/org-manage-components/deviceControlRuleCondition/Index'
import OrgManageDeviceControlRuleActionComponent from '@/components/org-manage-components/deviceControlRuleAction/Index'
import OrgManageDeviceControlRuleComponent from '@/components/org-manage-components/deviceControlRule/Index'
import OrgManageCameraPicComponent from '@/components/org-manage-components/cameraPic/Index'
import OrgManageCameraPosComponent from '@/components/org-manage-components/cameraPos/Index'
import OrgManageCameraPicDataSetComponent from '@/components/org-manage-components/cameraPic/PicDataSet'
import OrgManageDeviceInstantiationUserPropertyComponent from '@/components/org-manage-components/deviceInstantiationUserProperty/Index'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/index',
      name: 'index',
      component: Index
    },
    {
      path: '/dataV/index',
      name: 'dataVIndex',
      component: dataVIndex
    },
    {
      path: '/manage',
      name: 'ManageIndex',
      component: ManageIndex,
      children: [
        {
          path: '/manage/index',
          name: 'ManageIndexComponent',
          component: ManageIndexComponent
        },
        {
          path: '/manage/deviceControlSenceActionModel',
          name: 'ManageDeviceControlSenceActionModelComponent',
          component: ManageDeviceControlSenceActionModelComponent
        },
        {
          path: '/manage/aiDataSet',
          name: 'ManageAiDataSetComponent',
          component: ManageAiDataSetComponent
        },
        {
          path: '/manage/aiDataSetAnalysis',
          name: 'ManageAiDataSetAnalysisComponent',
          component: ManageAiDataSetAnalysisComponent
        },
        {
          path: '/manage/aiDataSetLabel',
          name: 'ManageAiDataSetLabelComponent',
          component: ManageAiDataSetLabelComponent
        },
        {
          path: '/manage/dict',
          name: 'ManageDictComponent',
          component: ManageDictComponent
        },
        {
          path: '/manage/log',
          name: 'ManageLogComponent',
          component: ManageLogComponent
        },
        {
          path: '/manage/organization',
          name: 'ManageOrganizationComponent',
          component: ManageOrganizationComponent
        },
        {
          path: '/manage/permission',
          name: 'ManagePermissionComponent',
          component: ManagePermissionComponent
        },
        {
          path: '/manage/user',
          name: 'ManageUserComponent',
          component: ManageUserComponent
        },
        {
          path: '/manage/role',
          name: 'ManageRoleComponent',
          component: ManageRolerComponent
        },
        {
          path: '/manage/notice',
          name: 'ManageNoticeComponent',
          component: ManageNoticeComponent
        },
        {
          path: '/manage/news',
          name: 'ManageNewsComponent',
          component: ManageNewsComponent
        },
        {
          path: '/manage/deviceProject',
          name: 'ManageDeviceProjectComponent',
          component: ManageDeviceProjectComponent
        },
        {
          path: '/manage/deviceModel',
          name: 'ManageDeviceModelComponent',
          component: ManageDeviceModelComponent
        },
        {
          path: '/manage/deviceModelProperty',
          name: 'ManageDeviceModelPropertyComponent',
          component: ManageDeviceModelPropertyComponent
        },
        {
          path: '/manage/camera',
          name: 'ManageCameraComponent',
          component: ManageCameraComponent
        },
        {
          path: '/manage/diseaseInsectPest',
          name: 'DiseaseInsectPestComponent',
          component: DiseaseInsectPestComponent
        },
        {
          path: '/manage/diseaseInsectPestDrug',
          name: 'DiseaseInsectPestDrugComponent',
          component: DiseaseInsectPestDrugComponent
        },
        {
          path: '/manage/chemicalComposition',
          name: 'ChemicalCompositionComponent',
          component: ChemicalCompositionComponent
        },
        {
          path: '/manage/components',
          name: 'ComponentsComponent',
          component: ComponentsComponent
        },
        {
          path: '/manage/drug',
          name: 'DrugComponent',
          component: DrugComponent
        },
        {
          path: '/manage/biota',
          name: 'BiotaComponent',
          component: BiotaComponent
        },
        {
          path: '/manage/biotaGrowthModel',
          name: 'BiotaGrowthModelComponent',
          component: BiotaGrowthModelComponent
        },
        {
          path: '/manage/biotaGrowthStage',
          name: 'BiotaGrowthStageComponent',
          component: BiotaGrowthStageComponent
        },
        {
          path: '/manage/biotaGrowthStageDiseaseInsectPest',
          name: 'BiotaGrowthStageDiseaseInsectPestComponent',
          component: BiotaGrowthStageDiseaseInsectPestComponent
        },
        {
          path: '/manage/biotaGrowthStageImages',
          name: 'BiotaGrowthStageImagesComponent',
          component: BiotaGrowthStageImagesComponent
        },
        {
          path: '/manage/biotaGrowthStageManureFeed',
          name: 'BiotaGrowthStageManureFeedComponent',
          component: BiotaGrowthStageManureFeedComponent
        },
        {
          path: '/manage/biotaGrowthStageModelAricultureOpt',
          name: 'BiotaGrowthStageModelAricultureOptComponent',
          component: BiotaGrowthStageModelAricultureOptComponent
        },
        {
          path: '/manage/growthCondition',
          name: 'GrowthConditionComponent',
          component: GrowthConditionComponent
        },
        {
          path: '/manage/knowledge',
          name: 'KnowledgeComponent',
          component: KnowledgeComponent
        },
        {
          path: '/manage/knowledgeBiota',
          name: 'KnowledgeBiotaComponent',
          component: KnowledgeBiotaComponent
        },
        {
          path: '/manage/manureFeed',
          name: 'ManureFeedComponent',
          component: ManureFeedComponent
        },
        {
          path: '/manage/diseaseInsectPestImage',
          name: 'DiseaseInsectPestImageComponent',
          component: DiseaseInsectPestImageComponent
        },
        {
          path: '/manage/deviceOta',
          name: 'ManageDeviceOtaComponent',
          component: ManageDeviceOtaComponent
        },
        {
          path: '/manage/deviceOtaRecord',
          name: 'ManageDeviceOtaRecordComponent',
          component: ManageDeviceOtaRecordComponent
        },
        {
          path: '/manage/deviceInstantiation',
          name: 'ManageDeviceInstantiationComponent',
          component: ManageDeviceInstantiationComponent
        }
      ]
    },
    {
      path: '/org-manage',
      name: 'OrgManageIndex',
      component: ManageIndex,
      children: [
        {
          path: '/org/manage/aiDataSet',
          name: 'OrgManageAiDataSetComponent',
          component: OrgManageAiDataSetComponent
        },         
        {
          path: '/org/manage/analysis',
          name: 'OrgManageAnalysisComponent',
          component: OrgManageAnalysisComponent
        },        
        {
          path: '/org/manage/index',
          name: 'OrgManageIndexComponent',
          component: OrgManageIndexComponent
        },
        {
          path: '/org/manage/department',
          name: 'OrgManageDepartmentComponent',
          component: OrgManageDepartmentComponent
        },
        {
          path: '/org/manage/log',
          name: 'OrgManageLogComponent',
          component: OrgManageLogComponent
        },
        {
          path: '/org/manage/organization',
          name: 'ManageOrganizationComponent',
          component: OrgManageOrganizationComponent
        },
        {
          path: '/org/manage/user',
          name: 'OrgManageUserComponent',
          component: OrgManageUserComponent
        },
        {
          path: '/org/manage/notice',
          name: 'OrgManageNoticeComponent',
          component: OrgManageNoticeComponent
        },
        {
          path: '/org/manage/userInfo',
          name: 'OrgManageUserInfoComponent',
          component: OrgManageUserInfoComponent
        },
        {
          path: '/org/manage/news',
          name: 'OrgManageNewsComponent',
          component: OrgManageNewsComponent
        },
        {
          path: '/org/manage/ground',
          name: 'OrgManageGroundComponent',
          component: OrgManageGroundComponent
        },
        {
          path: '/org/manage/camera',
          name: 'OrgManageCameraComponent',
          component: OrgManageCameraComponent
        },
        {
          path: '/org/manage/deviceInstantiationGroup',
          name: 'OrgManageDeviceInstantiationGroupComponent',
          component: OrgManageDeviceInstantiationGroupComponent
        },
        {
          path: '/org/manage/deviceInstantiation',
          name: 'OrgManageDeviceInstantiationComponent',
          component: OrgManageDeviceInstantiationComponent
        },
        {
          path: '/org/manage/deviceControlSence',
          name: 'OrgManageDeviceControlSenceComponent',
          component: OrgManageDeviceControlSenceComponent
        },
        {
          path: '/org/manage/deviceControlRuleCondition',
          name: 'OrgManageDeviceControlRuleConditionComponent',
          component: OrgManageDeviceControlRuleConditionComponent
        },
        {
          path: '/org/manage/deviceControlRuleAction',
          name: 'OrgManageDeviceControlRuleActionComponent',
          component: OrgManageDeviceControlRuleActionComponent
        },
        {
          path: '/org/manage/deviceControlRule',
          name: 'OrgManageDeviceControlRuleComponent',
          component: OrgManageDeviceControlRuleComponent
        },
        {
          path: '/org/manage/biota',
          name: 'BiotaComponent',
          component: BiotaComponent
        },
        {
          path: '/org/manage/biotaGrowthModel',
          name: 'BiotaGrowthModelComponent',
          component: BiotaGrowthModelComponent
        },
        {
          path: '/org/manage/biotaGrowthStage',
          name: 'BiotaGrowthStageComponent',
          component: BiotaGrowthStageComponent
        },
        {
          path: '/org/manage/biotaGrowthStageDiseaseInsectPest',
          name: 'BiotaGrowthStageDiseaseInsectPestComponent',
          component: BiotaGrowthStageDiseaseInsectPestComponent
        },
        {
          path: '/org/manage/biotaGrowthStageImages',
          name: 'BiotaGrowthStageImagesComponent',
          component: BiotaGrowthStageImagesComponent
        },
        {
          path: '/org/manage/biotaGrowthStageManureFeed',
          name: 'BiotaGrowthStageManureFeedComponent',
          component: BiotaGrowthStageManureFeedComponent
        },
        {
          path: '/org/manage/biotaGrowthStageModelAricultureOpt',
          name: 'BiotaGrowthStageModelAricultureOptComponent',
          component: BiotaGrowthStageModelAricultureOptComponent
        },
        {
          path: '/org/manage/growthCondition',
          name: 'GrowthConditionComponent',
          component: GrowthConditionComponent
        },
        {
          path: '/org/manage/knowledge',
          name: 'KnowledgeComponent',
          component: KnowledgeComponent
        },
        {
          path: '/org/manage/knowledgeBiota',
          name: 'KnowledgeBiotaComponent',
          component: KnowledgeBiotaComponent
        },
        {
          path: '/org/manage/manureFeed',
          name: 'ManureFeedComponent',
          component: ManureFeedComponent
        },
        {
          path: '/org/manage/diseaseInsectPestImage',
          name: 'DiseaseInsectPestImageComponent',
          component: DiseaseInsectPestImageComponent
        },
        {
          path: '/org/manage/aricultureOpt',
          name: 'AricultureOptComponent',
          component: AricultureOptComponent
        },
        {
          path: '/org/manage/aricultureOptBiotaGrowthStage',
          name: 'AricultureOptBiotaGrowthStageComponent',
          component: AricultureOptBiotaGrowthStageComponent
        },
        {
          path: '/org/manage/aricultureOptBiotaGrowthStageFile',
          name: 'AricultureOptBiotaGrowthStageFileComponent',
          component: AricultureOptBiotaGrowthStageFileComponent
        },
        {
          path: '/org/manage/aricultureOptDrug',
          name: 'AricultureOptDrugComponent',
          component: AricultureOptDrugComponent
        },
        {
          path: '/org/manage/aricultureOptManureFeed',
          name: 'AricultureOptManureFeedComponent',
          component: AricultureOptManureFeedComponent
        },
        {
          path: '/org/manage/cameraPicComponent',
          name: 'OrgManageCameraPicComponent',
          component: OrgManageCameraPicComponent
        },
        {
          path: '/org/manage/cameraPosComponent',
          name: 'OrgManageCameraPosComponent',
          component: OrgManageCameraPosComponent
        },
        {
          path: '/org/manage/cameraPicDataSet',
          name: 'OrgManageCameraPicDataSetComponent',
          component: OrgManageCameraPicDataSetComponent
        },
        {
          path: '/org/manage/deviceInstantiationUserProperty',
          name: 'OrgManageDeviceInstantiationUserPropertyComponent',
          component: OrgManageDeviceInstantiationUserPropertyComponent
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js